import { render } from "./Detalle.vue?vue&type=template&id=c3df0d46"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoGanaderos/Acopio/Detalle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3df0d46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3df0d46', __exports__)) {
    api.reload('c3df0d46', __exports__)
  }
  
  module.hot.accept("./Detalle.vue?vue&type=template&id=c3df0d46", () => {
    api.rerender('c3df0d46', render)
  })

}


export default __exports__